<template>
  <v-container class="expiration-display-container pa-0">
    <label>Alert Expires In</label>
    <div class="ml-3">
      {{ name }} <br />
      <div class="expiration-display" v-if="expirationDate">
        Expire {{ expirationDate }}
      </div>
    </div>
  </v-container>
</template>
<script>
import dayjs from "dayjs";

export default {
  name: "ExpirationDisplay",
  props: {
    value: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
  },
  computed: {
    name() {
      if (this.value && this.value.name) {
        return this.value.name.toUpperCase();
      }
      return null;
    },
    expirationDate() {
      return dayjs()
        .add(this.value.value, this.value.type)
        .format("MMM DD, YYYY");
    },
  },
};
</script>
<style scoped>
.expiration-display-container {
  padding: 5px;
}
.expiration-display {
  color: #3eaeff;
  font-size: 12px;
  padding: 5px 0;
}
label {
  font-family: TruenoRg;
  font-size: 16px;
}
</style>
